import { createAction, props } from '@ngrx/store';
import { ScannerSettingsState, SettingsReducerInitialState } from '../reducers/settings.reducer';

const prefix = '[Settings]';

export const setSettingsStateAction = createAction(
  `${prefix} set state`,
  props<Partial<SettingsReducerInitialState>>(),
);

export const updateScannerSettingsAction = createAction(
  `${prefix} update scanner settings`,
  props<{ scanner: Partial<ScannerSettingsState> }>(),
);
